import { Directive, effect, inject, Input, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

@Directive({
    standalone: true,
    selector: '[featureFlag]'
})
export class FeatureFlagDirective {
    private featureFlagService = inject(FeatureFlagService);
    private templateRef = inject(TemplateRef);
    private viewContainer = inject(ViewContainerRef);
    private hasView = false;
    private feature = signal('');

    @Input()
    set featureFlag(feature: string) {
        this.feature.set(feature);
    }

    constructor() {
        effect(() => {
            const featureName = this.feature();
            if (!featureName) return;
            const show = this.featureFlagService.isFeatureVisible(featureName)();
            if (show && !this.hasView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            } else if (!show && this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
        });
    }
}
